import { getBoggleProgressRepository } from '~/boggle/progress/webProgressRepository'

/** Repository-backed badge progress for the Compendium / progress hub. */
export async function loadBoggleCompendiumProgress() {
  return getBoggleProgressRepository().getBadgeProgress()
}
